module.exports = __webpack_public_path__ + "img/mastercard_icon.3960e759.svg";